import React from 'react';
import ups1 from '../../../../assets/img/desktop/23d3e669-2250-44f1-83e6-01d3b85f64cb.jpg';
import ups2 from '../../../../assets/img/desktop/ca4cdf11-311f-40f2-83d5-9ed6d1a150f6.png';
import './CDContinuidadElectrica.css';

function CDContinuidadElectrica() {

    return (
        <main id="CDContinuidadElectrica" >
            <section id="CDCE-c1">
                <h2>Continuidad Eléctrica</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Continuidad Eléctrica</li>
                </ul>
            </section>
            <section id="CDCE-c2">
                <figure id="CDCE-c2__image">
                    <img src={ups1} alt="Mantenimiento de UPS" />
                </figure>
                <div id="CDCE-c2__text">
                    <h4>Soluciones completas en sistemas de energía de respaldo<strong> para garantizar la continuidad operativa.</strong></h4>
                    <p>Ofrecemos servicios especializados en UPS, estabilizadores de voltaje y baterías para sistemas críticos. Nuestros equipos garantizan 
                        la protección de sus sistemas contra interrupciones eléctricas, fluctuaciones de voltaje y picos de corriente, asegurando operatividad 
                        constante en industrias, centros de datos, hospitales y comercios.</p>
                </div>
            </section>
            <section id="CDCE-c3">
                <div id="CDCE-c3__text">
                    <div id="CDCE-c3__text--parrafos">
                        <p>A través de nuestro modelo de entrega único, <strong>INFRASOL</strong> provee servicios rentables; basados en Acuerdos de Niveles de Servicio (SLAs); soportados
                            por una metodología de entrega madura, alineada a las mejores prácticas y soportado en un sólido programa de calidad.</p>
                        <p>Contamos con experiencia en planificación, diseño, implementación y gestión de proyectos de soluciones de energía
                            para resolver los requerimientos técnicos o de negocios específicos de clientes, integrando tecnología y servicios.</p>
                        <p>Nuestros servicios garantizan protección integral frente a picos, caídas de tensión y distorsiones armónicas, aumentando 
                            la vida útil de los equipos eléctricos y electrónicos, y reduciendo fallas por fluctuaciones de energía.</p>
                        <p className="parrafo-fases">Nuestros servicios incluyen:</p>
                    </div>
                    <div id="CDCE-c3__text--image">
                        <figure>
                            <img src={ups2} alt="Mantenimiento de UPS" />
                        </figure>
                    </div>
                </div>
                <div id="CDCE-c3__fases">
                    <div id="CDCE-c3__fases--item1">
                        <div className="item1-fases">
                            <h3>Suministro e Instalación de Estabilizadores</h3>
                            <div></div>
                            <p>Ofrecemos venta, instalación, reparación y fabricación de estabilizadores monofásicos, trifásicos y ferroresonantes, 
                                diseñados para proteger tus equipos eléctricos y electrónicos frente a fluctuaciones de voltaje, picos de corriente y 
                                variaciones en la red eléctrica. Equipos con tecnología de regulación servo-controlada o electrónica, con diseño y 
                                fabricación personalizada para aplicaciones especiales.</p>
                        </div>
                        <div className="item1-fases">
                            <h3>Suministro e Instalación de Baterías para UPS</h3>
                            <div></div>
                            <p>Brindamos soluciones completas para el suministro, reemplazo, instalación y mantenimiento de baterías para sistemas UPS 
                                (de todas las marcas y capacidades). Selección de baterías VRLA, AGM, GEL o Litio, garantizando compatibilidad total 
                                con el UPS. Servicio técnico disponible 24/7 para emergencias.</p>
                        </div>
                    </div>
                    <div id="CDCE-c3__fases--item2">
                        <h3>Mantenimiento Preventivo y Correctivo de UPS</h3>
                        <div></div>
                        <ul>
                            <li>Mantenimiento preventivo programado según horas de operación o criticidad del sistema.</li>
                            <li>Inspección interna y limpieza profunda de tarjetas, ventiladores y contactos.</li>
                            <li>Verificación de voltajes de entrada/salida, frecuencia y autonomía real.</li>
                            <li>Actualización de firmware y calibración de parámetros eléctricos.</li>
                            <li>Soporte técnico para eventos críticos, alarmas o fallas mayores.</li>
                            <li>Contratos de mantenimiento mensual, trimestral o anual según necesidad.</li>
                            <li>Generación de informes técnicos con recomendaciones de mejora.</li>
                            <li>Reducción de fallas inesperadas y prolongación de la vida útil de equipos y baterías.</li>                          
                        </ul>
                        <div className="CDCE-c3__fases--item2__images">
                            <figure>
                                <img src={ups1} alt="Mantenimiento de UPS" />
                            </figure>
                            <figure>
                                <img src={ups2} alt="Sistema UPS" />
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default CDContinuidadElectrica;

